module.exports = __webpack_public_path__ + "static/media/subscriptions-image.a9005aac.png";